// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import StarGray from '../_raw/ui/icon_star_gray.svg';
import withIconProps from '../withIconProps';

export default withIconProps(StarGray);
